import { useRef, useEffect } from 'react';
import { saveService } from '../../services/SaveService';
import { drawDungeonMap } from '../../utils/dungeon-map-draw';
import './Minimap.scss';

const PIXEL_SIZE = 6;
const UPDATE_INTERVAL = 200; // ms

export const Minimap = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const draw = () => {
      const canvas = canvasRef.current;
      const mapData = saveService.getMapData();
      if (!canvas || !mapData) {
        return;
      }

      const { width, height } = mapData;
      canvas.width = width * PIXEL_SIZE;
      canvas.height = height * PIXEL_SIZE;

      const ctx = canvas.getContext('2d');
      if (!ctx) {
        return;
      }

      drawDungeonMap({
        ctx,
        pixelSize: PIXEL_SIZE,
        revealAll: false,
        showGlyphs: false,
        showRoomDebug: false,
      });
    };

    draw();
    const interval = setInterval(draw, UPDATE_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="minimap">
      <canvas ref={canvasRef} />
    </div>
  );
};
